import { SessionRemoveDto, WebinarServiceError } from "../types/dto";
import { SessionStatus, WebinarSession } from "../types/models";

function removeStatus(
  session: Pick<WebinarSession, "id" | "status"> & {
    backendStatus?: SessionStatus;
  }
): SessionStatus {
  return session.backendStatus ?? session.status;
}

export function buildRemovePayload(
  session: Pick<WebinarSession, "id" | "status"> & {
    backendStatus?: SessionStatus;
  },
  opts?: { reason?: string; note?: string }
): SessionRemoveDto {
  const status = removeStatus(session);

  if (status === "draft") {
    return {
      id: session.id,
      kind: "delete_draft",
      note: opts?.note,
    };
  }

  if (status === "scheduled") {
    const reason = (opts?.reason || "").trim();
    if (!reason) {
      throw new WebinarServiceError(
        "VALIDATION",
        "A cancel reason is required"
      );
    }
    return {
      id: session.id,
      kind: "cancel_scheduled",
      reason,
      note: opts?.note?.trim() || undefined,
    };
  }

  throw new WebinarServiceError(
    "INVALID_TRANSITION",
    `Cannot remove a ${status} session`
  );
}
